<template>
    <div class="catalog-preview-photo__container">
        <div 
            class="catalog-preview-photo"
            @click="onClickPhotoMiddle"
        >
            <BasePreloaderSkeleton v-if="isLoading"/>

            <LinceIconArrowLeft
                v-if="isSliderModeShow"
                class="catalog-preview-photo__arrow catalog-preview-photo__arrow_left"
                @click.native.stop="toPrevPhoto"
            />

            <img
                v-if="photoDataMiddle"
                :src="photoDataMiddle"
                class="catalog-preview-photo__img"
            >

            <LinceIconArrowRight
                v-if="isSliderModeShow"
                class="catalog-preview-photo__arrow catalog-preview-photo__arrow_right"
                @click.native.stop="toNextPhoto"
            />

            <div
                v-if="isSliderModeShow"
                class="catalog-preview-photo__pagination"
            >
                <div
                    v-for="paginationIndex in photoData.length"
                    :key="paginationIndex"
                    :class="{'catalog-preview-photo__pagination-item_active' : getIsPaginationItemActive(paginationIndex)}"
                    class="catalog-preview-photo__pagination-item"
                />
            </div>
        </div>

        <AppPopup
			v-if="isPhotoBig"
			@close="onClosePhotoBig"
		>
			<div class="catalog-preview-photo__popup">
                <LinceIconArrowLeft
                    v-if="isSliderModeShow"
                    class="catalog-preview-photo__arrow catalog-preview-photo__arrow-popup catalog-preview-photo__arrow_left catalog-preview-photo__arrow-popup_left"
                    @click.native="toPrevPhoto"
                />

				<img
                    v-if="photoDataBig"
                    :src="photoDataBig" 
                    class="catalog-preview-photo__img_big"
                >

                <LinceIconArrowRight
                    v-if="isSliderModeShow"
                    class="catalog-preview-photo__arrow catalog-preview-photo__arrow-popup catalog-preview-photo__arrow_right catalog-preview-photo__arrow-popup_right"
                    @click.native="toNextPhoto"
                />
			</div>
		</AppPopup>
    </div>
</template>

<script>
import BasePreloaderSkeleton from '../Base/BasePreloaderSkeleton.vue';
import AppPopup from '@/components/Popup';
export default {
    name: 'CatalogPreviewPhoto',
    components: { 
        BasePreloaderSkeleton,
        AppPopup
    },
    props: {
        photoData: {
            type: Array,
            default: () => ([])
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        isPhotoBig: false,
        photoCurrentIndex: 0
    }),
    computed: {
        photoDataMiddle() {
            return String(this.photoData[this.photoCurrentIndex]?.middle ?? '');
        },
        photoDataBig() {
            return String(this.photoData[this.photoCurrentIndex]?.big ?? '');
        },
        isSliderModeShow() {
            return this.photoData.length > 1;
        }
    },
    methods: {
        onClickPhotoMiddle() {
            this.isPhotoBig = true;
        },
        onClosePhotoBig() {
            this.isPhotoBig = false;
        },
        getIsPaginationItemActive(paginationIndex) {
            return this.photoCurrentIndex === parseInt(paginationIndex - 1);
        },
        toPrevPhoto() {
            if (this.photoCurrentIndex > 0)
                this.photoCurrentIndex -= 1;
            else
                this.photoCurrentIndex = this.photoData.length - 1;
        },
        toNextPhoto() {
            if (this.photoCurrentIndex < this.photoData.length - 1)
                this.photoCurrentIndex += 1;
            else
                this.photoCurrentIndex = 0;
        },
    }
}
</script>

<style lang="scss" scoped>
    .catalog-preview-photo {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: pointer;

        &__popup {
            width: 832px;
            height: 632px;
            position: relative;
        }

        &__img {
            width: 100%;
            max-height: 100%;
            object-fit: cover;
            border-radius: 10px;

            &_big {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        &__arrow {
            width: 50px;
            height: 50px;
            position: absolute;
            top: 50%;

            ::v-deep {
                path {
                    fill: #fff;
                }
            }

            &:hover {
                ::v-deep {
                    path {
                        fill: #1f79d2;
                    }
                }
            }

            &-popup {
                width: 50px;
                height: 50px;
                cursor: pointer;
                z-index: 1;

                &_left {
                    left: 20px;
                }

                &_right {
                    right: 20px;
                }
            }

            // &_left {
            //     transform: rotate(90deg);
            // }

            &_right {
                right: 0;
            }
        }

        &__pagination {
            position: absolute;
            top: 90%;
            // top: 105%;
            width: 100%;
            display: flex;
            justify-content: center;

            &-item {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                // background: #fff;
                background: #cbcbcb;

                &:not(:last-child) {
                    margin-right: 5px;
                }

                &_active {
                    background: #1f79d2;
                }
            }
        }
    }
</style>